import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

export const COOKIE_CONSENT_STORAGE_KEY = 'trade-bot-cookie-consent';

const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  padding: 16px 20px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #1a2332 0%, #0f1419 100%);
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.35);
  color: #e2e8f0;
  font-size: 14px;
  line-height: 1.5;
`;

const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const TextBlock = styled.div`
  flex: 1;
  min-width: 240px;
  max-width: 720px;

  strong {
    font-weight: 600;
    color: #f8fafc;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

const Button = styled.button`
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ButtonSecondary = styled(Button)`
  background: transparent;
  color: #cbd5e1;
  border: 1px solid rgba(148, 163, 184, 0.4);

  &:hover {
    border-color: #94a3b8;
    background: rgba(148, 163, 184, 0.1);
  }
`;

const ButtonPrimary = styled(Button)`
  background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
  color: #0f1419;
  box-shadow: 0 4px 14px rgba(14, 165, 233, 0.35);

  &:hover {
    box-shadow: 0 6px 20px rgba(14, 165, 233, 0.45);
  }
`;

function readStoredConsent() {
  try {
    return localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
  } catch {
    return null;
  }
}

function CookiesConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!readStoredConsent());
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'accepted');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  const decline = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'rejected');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Bar role="dialog" aria-label="Cookie consent" aria-live="polite">
      <Inner>
        <TextBlock>
          <strong>Cookies.</strong> We use cookies and similar technologies to run the site (for example login
          sessions), remember preferences such as dashboard theme, and improve the product. By clicking &quot;Accept
          all&quot;, you agree to this use. You can decline optional cookies; strictly necessary cookies may still be
          required for security and authentication.
        </TextBlock>
        <Actions>
          <ButtonSecondary type="button" onClick={decline}>
            Decline optional
          </ButtonSecondary>
          <ButtonPrimary type="button" onClick={accept}>
            Accept all
          </ButtonPrimary>
        </Actions>
      </Inner>
    </Bar>
  );
}

export default CookiesConsent;
